<template>
  <div class="food-manage">
    <div class="food-search tuolele-main-box">
      <div class="tuolele-main-search tuolele-main-search-item">
        <el-form class="fn-clear" :inline="true">
          <el-form-item class="fn-left">
            <el-input v-model="listQuery.goods_name" placeholder="请输入物品名称" />
          </el-form-item>

          <el-form-item class="fn-left">
            <wq-select :selected.sync="listQuery.shop_id" placeholder="请选择校区" value-name="id" text-name="name" :data-func="$http.getShopList" />
          </el-form-item>

          <!-- <el-form-item label="" class="fn-left">
            <el-checkbox v-model="listQuery.tll_status" true-label="20062018214508001072" false-label="">只看已无效的例子</el-checkbox>
          </el-form-item> -->
          <el-form-item label="" class="fn-left">
            <el-button type="success" @click="fnUpdateTable()">搜索</el-button>
          </el-form-item>
          <el-form-item label="" class="fn-right">
            <el-button type="primary" @click="fnAdd()">添加物品</el-button>
          </el-form-item>
          <!-- <el-form-item label="" class="fn-right">
            <el-button type="primary" @click="fnCreate()">新增物品</el-button>
          </el-form-item> -->
        </el-form>
      </div>
    </div>
    <div class="tuolele-main-box">
      <wq-table ref="puchselisttable" :other-query="listQuery" :url-func="$http.getShopStockList">
        <el-table-column label="店铺" prop="shop_name" align="center" />
        <el-table-column label="编号" prop="goods_id" align="center" />
        <el-table-column label="图片" align="center">
          <template slot-scope="{row}">
            <el-image :src="row.goods_picture" :preview-src-list="[row.goods_picture]" />
          </template>
        </el-table-column>
        <el-table-column label="名称" prop="goods_name" align="center" />
        <el-table-column label="兑换积分" prop="integral" align="center" />
        <el-table-column label="库存" prop="total_num" align="center">
          <template slot-scope="{row}">
            {{ row.total_num - row.consume_num }}
          </template>
        </el-table-column>

        <el-table-column label="操作" align="center" width="260">
          <template slot-scope="{row}">
            <el-button size="mini" type="text" @click="fnUpdateStock(row)">库存配置</el-button>
            <el-dropdown>
              <span class="el-dropdown-link">
                <el-button size="mini" type="text">更多</el-button><i class="el-icon-arrow-down " />
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="fnConsume(row)">物品消耗</el-dropdown-item>
                <el-dropdown-item style="color:red" divided @click.native="fnTrashStock(row)">清空库存</el-dropdown-item>

              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </wq-table>

    </div>
    <el-dialog
      title="添加物品"
      :visible.sync="dialogVisible1"
      width="80%"
    >
      <el-form class="fn-clear" :inline="true">
        <el-form-item class="fn-left">
          <el-input v-model="searchListQuery.goods_name" placeholder="请输入物品名称" />
        </el-form-item>
        <el-form-item label="" class="fn-left">
          <el-button type="success" @click="$refs['searchgoodslist'].fetchTableData()">搜索</el-button>
        </el-form-item>
      </el-form>
      <wq-table :key="`searchgoodslist${searchgoodtablekey}`" ref="searchgoodslist" sub-key="list" :other-query="searchListQuery" :url-func="$http.seachGoodsList">
        <el-table-column label="ID" prop="id" align="center" />
        <el-table-column label="名称" prop="name" align="center" />
        <el-table-column label="图片" align="center">
          <template slot-scope="{row}">
            <el-image :src="row.photo" :preview-src-list="[row.photo]" />
          </template>
        </el-table-column>
        <el-table-column label="单价（元）" prop="money" align="center" />
        <el-table-column label="总部库存" prop="stock" align="center" />
        <el-table-column label="操作" align="center" width="260">
          <template slot-scope="{row}">
            <el-button type="primary" size="mini" @click="fnAddToShop(row)">添加</el-button>
          </template>
        </el-table-column>
      </wq-table>
    </el-dialog>
    <el-dialog
      title="库存增减"
      :visible.sync="dialogVisible2"
      width="80%"
    >
      <form-box key="changestockform" label-width="120px" :forms="changeForms" :post-form="changePostForm" @submit="fnSubmitStockChange" />
    </el-dialog>
    <el-dialog
      :title="`${currentGoodsTitle}-存变变更`"
      :visible.sync="dialogVisible3"
      width="80%"
      custom-class="changestockform"
    >
      <el-timeline>
        <el-timeline-item
          v-for="(change, index) in changeHistoryLists"
          :key="index"
        >
          <el-card>
            <div class="fn-clear">
              <h4 class="fn-left">操作人:{{ change.editor_name }}</h4>
              <h4 class="fn-right">{{ change.modify_time }}</h4>
            </div>
            <div v-html="change.remark" />
          </el-card>
        </el-timeline-item>
      </el-timeline>
    </el-dialog>

  </div>

</template>
<script>

import WqTable from '@/components/WqTable'
import FormBox from '@/components/FormBox'
import WqSelect from '@/components/FormBox/WqSelect'

const defaultChangeGoodsPostForm = {
  shop_id: '',
  goods_id: '',
  change_num: '',
  remark: ''
}

export default {
  name: 'TurnStudentList',
  components: {
    // Select
    WqTable,
    FormBox,
    WqSelect
  },

  data() {
    return {
      lists: [],
      changeForms: [
        { type: 'inputnumber', bindValue: 'change_num', label: '数量调整', require: true },
        { type: 'input', bindValue: 'remark', label: '备注', require: true }
      ],
      changePostForm: Object.assign({}, defaultChangeGoodsPostForm),
      tableKey: 0,
      dialogVisible1: false,
      dialogVisible2: false,
      dialogVisible3: false,
      currentGoodsTitle: '',
      changeHistoryLists: [],
      searchgoodtablekey: 0,
      total: 0,
      listQuery: {
        shop_id: '',
        goods_name: ''
      },
      searchListQuery: {
        goods_name: ''
      },
      changeLogListQuery: {
        shop_id: '',
        goods_id: ''
      }
    }
  },
  created() {

  },
  methods: {
    fnAdd() {
      if (!this.listQuery.shop_id) {
        this.$message({ type: 'error', message: '请选择校区' })
        return
      }
      this.searchgoodtablekey++
      this.dialogVisible1 = true
    },
    fnAddToShop(row) {
      this.$http.addShopGoods({ goods_id: row.id, shop_id: this.listQuery.shop_id }).then(res => {
        if (res.code == 200) {
          this.$message({ type: 'success', message: '添加成功!' })
          this.dialogVisible1 = false
          this.$refs['searchgoodslist'].fetchTableData()
        }
      })
    },
    fnUpdateStock(row) {
      this.changePostForm = Object.assign({}, defaultChangeGoodsPostForm, { goods_id: row.goods_id, shop_id: this.listQuery.shop_id })
      this.dialogVisible2 = true
    },

    fnConsume(row) {
      this.currentGoodsTitle = row.goods_name
      this.changeLogListQuery.shop_id = this.listQuery.shop_id
      this.changeLogListQuery.goods_id = row.goods_id
      this.$http.getShowChangeLog(this.changeLogListQuery).then(res => {
        this.changeHistoryLists = res.data
        this.dialogVisible3 = true
      })
    },
    fnTrashStock(row) {
      this.$confirm('确定清空该物品库存吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.clearShopGoodsStocks({ goods_id: row.goods_id, shop_id: this.listQuery.shop_id }).then(res => {
          if (res.code == 200) {
            this.$message({ type: 'success', message: '清空成功!' })
            this.fnUpdateTable()
          }
        })
      })
    },
    fnUpdateTable() {
      this.$refs['puchselisttable'].fetchTableData()
    },

    fnSubmitStockChange(postFrom) {
      this.$http.changeShopStock(postFrom).then((res) => {
        if (res.code == 200) {
          this.$message({ type: 'success', message: '库存操作成功!' })
          this.dialogVisible2 = false
          this.fnUpdateTable()
        }
      })
    }

  }
}
</script>
<style lang="scss">
.el-image-viewer__wrapper .el-icon-circle-close {
  color:white
}
  .food-search {
  .tuolele-main-search-item {
    margin-bottom: 0;
    padding: 0;
    border: 0;
    .el-form--inline .el-form-item {
      display: block;
    }
    .split-time{
      margin-right: 20px;
    }
    .el-select,
    .el-input {
      width: 160px !important;
      margin-right: 20px;
    }
    span.select-date {
      margin-right: 10px;
    }
    .button-group {
      margin-left: 82px;
    }
  }
}
.changestockform .el-dialog__body{
    height: 80vh;
    overflow-y: scroll;
  }
</style>

